import { GlobalStyles } from './GlobalStyles';
import { BrowserRouter } from 'react-router-dom';
import { useRoutes } from './routes/routes';

export const App = () => {
  const routes = useRoutes();

  return (
    <>
      <GlobalStyles />
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        {routes}
      </BrowserRouter>
    </>
  );
};
